import React from 'react';
import NavHeader from '../NavHeader/NavHeader';
import MainFooter from '../MainFooter/MainFooter';
import CommonPageHeader from '../CommonPageHeader/CommonPageHeader';
import PageHelmet from '../shared/PageHelmet';

const LegalPage = ({ title, description, path, effective, updated, intro, sections, company = 'Harsoft Solutions', note }) => {
   return (
      <>
         <PageHelmet pageTitle={title} description={description} path={path} />
         <NavHeader />
         <main>
            <CommonPageHeader title={title} subtitle={title} />
            <section className="pt-100 pb-100">
               <div className="tw-container tw-mx-auto">
                  <div style={{ maxWidth: 900, margin: '0 auto', lineHeight: 1.8 }}>
                     {effective && <p style={{ marginBottom: 0 }}><strong>Effective Date:</strong> {effective}</p>}
                     <p><strong>Last Updated:</strong> {updated}</p>
                     {intro.map((text, i) => <p key={i}>{text}</p>)}
                     {sections.map((section, i) => (
                        <div key={section.heading} className="mt-40">
                           <h2 style={{ fontSize: 26, marginBottom: 12 }}>{i + 1}. {section.heading}</h2>
                           {(section.content || [
                              ...(section.paragraphs || []),
                              ...(section.list ? [{ list: section.list }] : []),
                           ]).map((block, j) => {
                              if (typeof block === 'string') return <p key={j}>{block}</p>;
                              if (block.sub) return <h3 key={j} style={{ fontSize: 20, margin: '16px 0 8px' }}>{block.sub}</h3>;
                              return (
                                 <ul key={j} style={{ listStyle: 'disc', paddingLeft: 24 }}>
                                    {block.list.map((item) => (
                                       typeof item === 'string'
                                          ? <li key={item}>{item}</li>
                                          : <li key={item.label}><strong>{item.label}:</strong> {item.text}</li>
                                    ))}
                                 </ul>
                              );
                           })}
                        </div>
                     ))}
                     <div className="mt-40">
                        <h2 style={{ fontSize: 26, marginBottom: 12 }}>{sections.length + 1}. Contact Us</h2>
                        <p>
                           {company}<br />
                           Website: <a href="https://harsofts.com/">https://harsofts.com/</a><br />
                           Sai Aishwarya Layout Rd, Chitrapuri Colony, Khajaguda, Hyderabad, Telangana 500104, India<br />
                           Email: <a href="mailto:info@harsofts.com">info@harsofts.com</a><br />
                           Phone: <a href="tel:+919030350309">+91-90303 50309</a>
                        </p>
                        {note && <p className="mt-40" style={{ fontStyle: 'italic', borderTop: '1px solid #ddd', paddingTop: 16 }}>{note}</p>}
                     </div>
                  </div>
               </div>
            </section>
         </main>
         <MainFooter />
      </>
   );
};

export default LegalPage;
